import { Injectable } from '@angular/core';
import { ApiResourceService } from "../../apiResource/apiResource.service";
import { Observable, of as observableOf } from "rxjs";
import { map, tap } from "rxjs/operators";
import { EXRateType } from "libraries/interfaces/ITotal";

export interface ICurrencyRate {
    id: number;
    countryCode?: string;
    source: string;
    target: string;
    rate: number;
    type: EXRateType;
}

@Injectable()
export class CurrenciesResourceService {
    private readonly cache: Map<string, ICurrencyRate[]> = new Map();

    constructor(private readonly apiResourceService: ApiResourceService) {
    }

    public searchCurrenciesRates(source: string, target: string, type: EXRateType = EXRateType.cost): Observable<ICurrencyRate[]> {
        const cacheCode: string = `${source}-${target}-${type}`;
        if (this.cache && this.cache.has(cacheCode)) {
            return observableOf(this.cache.get(cacheCode));
        }
        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl('price', 'xrates', 'search'),
            {source, target, type},
        ).pipe(
            tap((response: ICurrencyRate[]) => {
                this.cache.set(cacheCode, response);
            })
        );
    }

    public searchRatesForTarget(target: string, type: EXRateType = EXRateType.cost): Observable<ICurrencyRate[]> {
        const cacheCode: string = `${target}-${type}`;

        if (this.cache && this.cache.has(cacheCode)) {
            return observableOf(this.cache.get(cacheCode));
        }

        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl('price', 'xrates', 'search'),
            {target, type},
        ).pipe(
            map((response: ICurrencyRate[]) => {
                    this.cache.set(cacheCode, response);
                    return this.cache.get(cacheCode);
                }
            )
        );
    }
}
